import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@opentelemetry+api@1.9.1_@playwright+test@1.61.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@opentelemetry+api@1.9.1_@playwright+test@1.61.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(marketing)/faq-accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitsGrid","GameTypesGrid"] */ "/app/src/app/(marketing)/interactive-cards.tsx");
